
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/brands/[brandId]",
      function () {
        return require("private-next-pages/default/desktop/brands/[brandId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/default/desktop/brands/[brandId]"])
      });
    }
  